/* eslint-disable no-restricted-globals */
const BFF_URL = 'https://ccdb-bff.dc68032.easn.morningstar.com';

export default function getRoot(): string {
    // 1. Runtime override via host shell or standalone index.html
    if (typeof window !== 'undefined' && (window as any).__API_ROOT__) {
        return (window as any).__API_ROOT__;
    }
    // 2. Local dev (localhost) — return empty so webpack proxy handles it
    if (typeof window !== 'undefined' && window.location?.hostname === 'localhost') {
        return '';
    }
    // 3. Production (MFE hosted on remote domain) — call BFF directly
    return BFF_URL;
}
